<template>
  <v-card flat>
    <!-- <form @submit.prevent="update" @keydown="form.onKeydown($event)"> -->
    <v-card-title primary-title>
      <h5 class="display-1 mb-0">Bewertungen auf Ihrem Betriebsprofil</h5>

    </v-card-title>
    <v-card-text class="mx-2">
      <p class="subheading mt-2">
        Hier können Sie aussuchen, ob Sie Ihre Google-Bewertungen auf Ihrem Betriebsprofil anzeigen wollen.
      </p>
    </v-card-text>
    <v-card-text class="mx-2">

      <v-layout
        row
        wrap
      >
        <v-flex
          xs12
          sm4
          class="mx-2"
        >
          <v-text-field
            label="Meine Google PlaceID"
            v-model="betrieb.placeid"
          ></v-text-field>
        </v-flex>
        <v-flex
          xs12
          sm4
          class="mx-2"
        >
          <v-select
            label="Welche Bewertungen sollen gezeigt werden?"
            v-model="ratingsselect"
            :items="ratings"
            item-text="text"
            item-value="value"
            disabled
          ></v-select>
        </v-flex>

        <v-flex
          xs12
          sm3
          class="mx-2 text-xs-right"
        >
          <v-btn
            @click="saveForm()"
            large
            color="accent"
          >
            <v-icon left>save</v-icon> Speichern
          </v-btn>
        </v-flex>

      </v-layout>

      <v-layout
        row
        wrap
      >
        <v-flex class="mx-2 pr-3 mt-4">

          <v-expansion-panel>
            <v-expansion-panel-content>
              <template v-slot:header>
                <div class="subheading font-weight-bold">Wie finde ich die Google Place ID meines Betriebes heraus?</div>
              </template>
              <v-card>
                <v-card-text class="subheading">
                  <ol>
                    <li>Suchen Sie auf folgender Seite nach Ihrem Betrieb: <a
                        href="https://developers.google.com/maps/documentation/javascript/examples/places-placeid-finder"
                        target="_blank"
                      > Place ID Finder</a>
                    </li>
                    <li>Kopieren Sie die angezeigte Place ID</li>
                    <li>Fügen Sie Ihre Place ID in das Feld ein und klicken Sie auf Speichern.</li>

                  </ol>

                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>

        </v-flex>
      </v-layout>

    </v-card-text>

    <v-card-text v-if="place">

      <h3 class="headline mt-3 mb-2">Angezeigte Bewertungen</h3>
      <div class="mx-2">

        <div v-if="filteredReviews">
          <v-layout
            row
            wrap
          >
            <v-flex
              xs6
              md4
              lg3
              v-for="review in filteredReviews"
              :key="review.index"
            >
              <v-card
                class="mx-2 my-3 pa-3"
                v-if="review.rating > 3"
              >
                <span class="subheading">
                  "{{ review.text }}"
                </span>

                <div class="text-xs-center mt-5">
                  <v-rating
                    v-model="review.rating"
                    color="yellow darken-3"
                    background-color="grey darken-1"
                    empty-icon="$vuetify.icons.ratingFull"
                    half-increments
                    readonly
                    large
                  ></v-rating>
                </div>
                <v-card-actions class="px-0 mx-0">
                  <v-list>
                    <v-list-tile class="grow px-0 mx-0">
                      <v-list-tile-avatar
                        color="grey darken-3"
                        class="px-0 mx-0"
                      >
                        <v-img
                          class="elevation-6"
                          :src="review.profile_photo_url"
                        ></v-img>
                      </v-list-tile-avatar>

                      <v-list-tile-content>
                        <v-list-tile-title>

                          <a
                            :href="review.author_url"
                            class="text-none font-weight-normal subheading"
                            target="_blank"
                          >{{ review.author_name }}</a>

                        </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile
                      class="grow mx-0 py-0 my-0"
                      style="height: 20px;padding-left: 60px;"
                    >

                      <v-list-tile-content class="my-0 py-0">
                        <v-list-tile-title class="body-1 my-0 py-0">

                          {{ review.relative_time_description }} bei Google

                        </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-card-actions>

              </v-card>
            </v-flex>
          </v-layout>

        </div>
        <div
          v-else-if="noratings"
          class="text-xs-center subheading"
        >
        Keine Kundenbewertungen vorhanden oder keine PlaceID gewählt.
         
        </div>
        <div
          v-else
          class="text-xs-center"
        >
          <v-progress-circular
            indeterminate
            color="accent"
          ></v-progress-circular>
        </div>
      </div>

      <v-layout
        row
        class="mt-3"
      >
        <!-- <v-btn v-on:click.native="saveForm()" large color="accent">Speichern</v-btn> -->
        <v-spacer></v-spacer>
        <v-btn
          @click="nexttab()"
          large
        >Weiter <v-icon right>chevron_right</v-icon>
        </v-btn>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
// let id = 3
// import Form from "vform";
import axios from 'axios'
import draggable from 'vuedraggable'

export default {
  props: {
    leistungen: Array,
    betrieb: ''
  },
  components: {
    draggable
  },
  name: 'leistung-view',

  // mounted () {
  //   const app = this
  //   // var LeistungenListe
  //   axios.get('/api/v1/meineleistung')
  //     .then(function (resp) {
  //       app.company = resp.data

  //       // LeistungenListe = app.company
  //     })
  //     .catch(function () {
  //       // alert("Konnte Firma nicht laden")
  //     })
  // },
  data () {
    return {
      ex7: false,

      e7: [],
      list: [],
      editedLeistung: null,
      message: 'yolo!',
      enabled: true,
      dragging: false,
      saveready: false,
      placeid: null,
      place: [],
      noratings: null,
      ratingsselect: { text: 'Ab 4 Sternen', value: 4 },
      ratings: [
        { text: 'Ab 1 Stern', value: 1 },
        { text: 'Ab 2 Sterne', value: 2 },
        { text: 'Ab 3 Sterne', value: 3 },
        { text: 'Ab 4 Sterne', value: 4 },
        { text: 'Ab 5 Sterne', value: 5 }
      ]
    }
  },
  mounted () {
    this.getRatings()
  },
  computed: {
    draggingInfo () {
      return this.dragging ? 'under drag' : ''
    },
    filteredReviews () {
      if (this.place) {
        if (this.place.result) {
          if (this.place.result.reviews) {
            return this.place.result.reviews.filter(
              (review) => review.rating > 1
            )
          }
        }
      }
    }
  },
  methods: {
    nexttab (event) {
      this.$emit('tabswitch')
    },
    getRatings: function () {
      this.noratings = false
      const app = this
      axios
        .get('/api/v1/place')
        .then(function (resp) {
          app.place = resp.data
          console.log(app.place)
        })
        .catch(function (error) {
          app.noratings = true
          // alert("Konnte Firma nicht laden")
          console.log(error)
        })
    },
    saveForm () {
      var app = this
      var newCompany = app.betrieb

      axios
        .patch('/api/v1/companies/' + app.betrieb.id, newCompany)
        .then((resp) => {
          this.$store.dispatch('responseMessage', {
            type: 'success',
            text: this.$t('betrieb_updated')
          })
          this.getRatings()
          // app.$router.replace('/meinbetrieb')
        })
        .catch((resp) => {
          this.$store.dispatch('responseMessage', {
            type: 'error',
            text: 'Fehler beim Speichern..'
          })
        })
    }
  }
}
</script>

<style scoped>
.button {
  margin-top: 35px;
}
.handle {
  float: left;
  padding-top: 8px;
  padding-bottom: 8px;
}
.close {
  float: right;
  padding-top: 8px;
  padding-bottom: 8px;
}
input {
  display: inline-block;
  width: 50%;
}
.text {
  margin: 20px;
}
</style>

